import { FaCheck } from "react-icons/fa";
import AddOn from "../../assets/AddOn.png"
const features = [
  "Build AI presentations natively in Google Slides",
  "Refine content and add AI images to your slides",
  "Smart layouts with automated content structuring",
  "Full two-way sync with Zynth Web",
  "Ideal for teams looking for AI slides built directly into their workflows",
];

export default function AddOnSection() {
  return (
    <div className="bg-gradient-to-b from-white to-[#f1f7fd] py-16 px-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
        <div className="w-full md:w-1/2">
          <div className="inline-block px-3 py-1 text-sm border border-gray-400 rounded-md mb-4 bg-[#2222221A]">
            Supercharge Google Slides with Zynth's AI engine
          </div>

          <h1 className="md:block text-3xl sm:text-4xl font-bold text-gray-900 z-10">
            Zynth Add-on for
          </h1>
          <h1 className="md:block text-3xl sm:text-4xl font-bold text-gray-900 z-10">
            Google Slides
          </h1>

          <p className="text-gray-700 mb-6 mt-4">
            Install our Google Workspace add-on to bring Zynth’s AI tool for PPT
            directly inside your workspace and never start from a blank slide.
          </p>

          <ul className="space-y-2 mb-8">
            {features.map((item, idx) => (
              <li
                key={idx}
                className="flex items-start gap-2 border-b pb-1 border-gray-300 last:border-none"
              >
                <FaCheck className="text-green-600 mt-1" />
                <span className="text-gray-800 text-sm sm:text-base">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>

      <div className="w-full md:w-1/2 p-6">
  <div
    className="h-full bg-gray-300 rounded-md shadow-inner w-full min-h-[28rem] overflow-hidden bg-no-repeat bg-contain bg-center"
    style={{ backgroundImage: `url(${AddOn})` }}
  />
</div>
</div>


      <div className="flex justify-center mt-10">
        <button
          className="bg-[#3667B2] text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-[#2f57a1] transition"
          onClick={() =>
            window.open(
              "https://workspace.google.com/marketplace/app/zynthai/704273243272",
              "_blank"
            )
          }
        >
          Install Google Slides Add-on
        </button>
      </div>
    </div>
  );
}


